import { Hint, Link } from "react-ui";
import * as React from "react";

import { isNotNullOrEmpty } from "../../../../../Common/TypingUtils";
import { Icon } from "../../Icons/Icon";

import { LinkInfoCard, TextInCard } from "./FormInfo.styles";

export const bannerMaxWidth = 304;

export interface LinkInfoProps {
    notice: string;
}

export const LinkInfo = ({ notice }: LinkInfoProps) => {
    const splitText = notice.split("|");

    return (
        <CustomLink link={splitText[2] ?? ""}>
            <Hint text={splitText[1]} pos={"bottom left"} maxWidth={bannerMaxWidth} useWrapper={true}>
                <LinkInfoCard>
                    <Icon name={"QuestionCircleIcon"} />
                    <TextInCard>{splitText[0]}</TextInCard>
                </LinkInfoCard>
            </Hint>
        </CustomLink>
    );
};

export interface CustomLinkProps {
    link: string;
    children: React.ReactNode;
}

const CustomLink = ({ link, children }: CustomLinkProps) =>
    isNotNullOrEmpty(link) ? (
        <Link href={link} target="_blank" rel="noreferrer">
            {children}
        </Link>
    ) : (
        <Link style={{ textDecoration: "none", cursor: "text" }}>{children}</Link>
    );
